import { TIMESERIES_MESSAGES } from '../messages/tooltips-text.js';

/**
 * Determines the appropriate message to display based on selection state.
 *
 * @param selectedDatapoints - Total number of selected datapoints
 * @param seriesCount - Total number of series within the chart
 * @returns The appropriate message definition for the current selection state
 */
export const getDatapointsMessage = (
  selectedDatapoints: number,
  seriesCount?: number,
) => {
  if (!selectedDatapoints) {
    return TIMESERIES_MESSAGES.noDatapoints;
  }

  if (seriesCount === 1) {
    return TIMESERIES_MESSAGES.datapoints;
  }

  return TIMESERIES_MESSAGES.seriesDatapoints;
};
